'use strict';

var mobileNav = function () {
  var menuWrapper = document.querySelector('.c-nav'),
    body = document.querySelector('body'),
    trigger = document.getElementById('js-hamburger');

    trigger.onclick = function() {
      console.log('click');
      this.classList.toggle('is-active');
      menuWrapper.classList.toggle('c-nav--expanded');
      body.classList.toggle('u-no-scroll');
    }
};

module.exports = mobileNav;
